<div
  class="omni-chat-header-wrapper change-align"
  [ngClass]="headerBackgroundClass$ | async"
>
  <div>
    <div class="back-cover" *ngIf="isHistory">
      <button
        [disabled]="isBackButtonDisabled$ | async"
        (click)="backToDialog()"
        data-qa-omni="headerBackButton"
        aria-label="back"
      >
        <cigna-icon type="chevron-thin-left" class="back"></cigna-icon>
      </button>
    </div>
    <div
      id="menu_icon"
      class="icon-more"
      [ngClass]="{ disabledClass: shouldCloseSplashScreen }"
      tabindex="0"
      aria-label="menu"
      (click)="isMenuOpen = !isMenuOpen"
      (keyup.enter)="isMenuOpen = !isMenuOpen"
      (focus)="isMenuOpen = false"
    >
      <cigna-icon type="icon-more" class="more-on"></cigna-icon>
    </div>
    <nav
      aria-label="menu dropdown"
      [ngClass]="isMenuOpen ? 'open' : 'closed'"
      class="menu nav-submenu"
    >
      <ul class="parent-ul">
        <li class="menuItem">
          <button
            tabindex="0"
            (click)="toggleMute()"
            *ngIf="isUnmuted$ | async"
          >
            <cigna-icon
              type="mute"
              (click)="toggleMute()"
              class="volume-onoff"
              *ngIf="isUnmuted$ | async"
            ></cigna-icon
            ><span>Mute Sounds</span>
          </button>
          <button
            tabindex="0"
            (click)="toggleMute()"
            *ngIf="(isUnmuted$ | async) === false"
          >
            <cigna-icon
              type="sound"
              (click)="toggleMute()"
              class="volume-onoff"
              *ngIf="(isUnmuted$ | async) === false"
            ></cigna-icon
            ><span>Unmute Sounds</span>
          </button>
        </li>
        <hr class="divider" />
        <li class="menuItem">
          <button tabindex="0" (click)="printEmitter.emit()">
            <cigna-icon type="file" class="volume-onoff"></cigna-icon
            ><span>Chat Transcript</span>
          </button>
        </li>
      </ul>
    </nav>
  </div>

  <div>
    <h2
      #headerTitle
      tabindex="-1"
      class="header-title"
      data-qa-omni="headerTitle"
      (focus)="isMenuOpen = false"
    >
      {{ title$ | async }}
    </h2>
  </div>
  <div *ngrxLet="shouldCloseOrExit$ as shouldCloseOrExit">
    <button
      (click)="closeOrEndChat(!shouldCloseOrExit)"
      data-qa-omni="closeOrEndChat"
      aria-label="close"
      (focus)="isMenuOpen = false"
    >
      <ng-container *ngIf="toggleButton$ | async as button">
        <cigna-icon type="close-thin" class="closeIcon"></cigna-icon>
      </ng-container>
    </button>
  </div>
</div>
